<script>
    export let currentRoute;

    let expanded;
</script>

<nav
    class="navbar is-fixed-top is-info"
    role="navigation"
    aria-label="main navigation"
>
    <div class="navbar-brand">
        <a
            role="button"
            class="navbar-burger {expanded ? 'is-active' : ''}"
            aria-label="menu"
            aria-expanded="false"
            data-target="navbarBasicExample"
            on:click="{() => expanded = expanded ? false : true}"
        >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
        </a>
    </div>

    <div id="navbarBasicExample" class="navbar-menu {expanded ? 'is-active' : ''}">
        <div class="navbar-start">
<!--             <div class="navbar-item has-dropdown is-hoverable">
                <a class="navbar-link"> Adoración Familiar </a>

                <div class="navbar-dropdown">
                    <a class="navbar-item"> Leer </a>
                    <a class="navbar-item"> Cantar </a>
                    <a class="navbar-item"> Orar </a>
                </div>
            </div> -->
            <div class="navbar-item has-dropdown is-hoverable">
                <a class="navbar-link"> Catecismo </a>

                <div class="navbar-dropdown">
                    <a class="navbar-item" on:click={() => {
                            currentRoute = 'cmdw';
                            expanded = false;
                        }
                    }>
                        El Catecismo Menor de Westminster
                    </a>

                    <a class="navbar-item" on:click={() => {
                            currentRoute = 'cdh';
                            expanded = false;
                        }
                    }>
                        El Catecismo de Heidelberg
                    </a>
                </div>
            </div>

            <div class="navbar-item has-dropdown is-hoverable">
                <a class="navbar-link"> Memoria </a>

                <div class="navbar-dropdown">
                    <a class="navbar-item" on:click={() => {
                            currentRoute = 'sdmt';
                            expanded = false;
                        }
                    }> Sistema de Memoria Temático </a>
                </div>
            </div>

            <div class="navbar-item has-dropdown is-hoverable">
                <a class="navbar-link"> Preguntas </a>

                <div class="navbar-dropdown">
                    <a class="navbar-item" href="https://preguntas.catequizar.org" target="_blank" rel="noopener" on:click={() => {
                            expanded = false;
                        }
                    }>
                        Preguntas difíciles sobre la Biblia
                    </a>
                </div>
            </div>
        </div>
        <div class="navbar-end">
            <a class="navbar-item" on:click={() => {
                    currentRoute = 'home';
                    expanded = false;
                }
            }>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="#FFF"
                    viewBox="0 0 256 256"
                >
                    <path
                        d="M218.83,103.77l-80-75.48a1.14,1.14,0,0,1-.11-.11,16,16,0,0,0-21.53,0l-.11.11L37.17,103.77A16,16,0,0,0,32,115.55V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V160h32v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V115.55A16,16,0,0,0,218.83,103.77ZM208,208H160V160a16,16,0,0,0-16-16H112a16,16,0,0,0-16,16v48H48V115.55l.11-.1L128,40l79.9,75.43.11.1Z"
                    ></path></svg
            ></a>
        </div>
    </div>
</nav>

<slot></slot>

<style></style>
